import { FileType } from '../../../enums/FileType';
import { ImageType } from '../../../enums/ImageType';

export class LocationValue {
  constructor(
    private readonly path: string | null,
    private readonly hostname: string | null,
    private readonly fileType: FileType,
    private readonly imageInfo: string | null,
    private readonly imageType: ImageType | null
  ) {}

  getPath() {
    return this.path ?? '';
  }

  getHostname() {
    return this.hostname;
  }

  getFileType() {
    return this.fileType;
  }

  getImageInfo() {
    return this.imageInfo;
  }

  getImageType() {
    return this.imageType;
  }
}
